var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.967,
    height: 28.967,
    viewBox: "0 0 28.967 28.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_shop",
    "data-name": "vuesax/bulk/shop",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.618.338v7.23A6.037,6.037,0,0,1,16.583,13.6H6.035A6.037,6.037,0,0,1,0,7.568V.422A4.921,4.921,0,0,0,3.633,1.979,4.94,4.94,0,0,0,7.531,0a4.531,4.531,0,0,0,3.778,1.979A4.507,4.507,0,0,0,15.063.048a4.948,4.948,0,0,0,3.862,1.931A4.816,4.816,0,0,0,22.618.338Z",
    transform: "translate(3.174 13.409)",
    fill: "#1899d7",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.155,0H.914L.02,8.883a4.693,4.693,0,0,0,.35,2.293,4.51,4.51,0,0,0,4.176,2.7,4.5,4.5,0,0,0,4.188-2.691A4.8,4.8,0,0,0,9.1,9.45V9.221Z",
    transform: "translate(9.937 1.509)",
    fill: "#1899d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.682,8.473l-.35-3.343C9.825,1.485,8.171,0,4.635,0H0L.893,9.052a4.335,4.335,0,0,1,.024.483,4.608,4.608,0,0,0,.555,1.726A5,5,0,0,0,5.793,13.88a4.806,4.806,0,0,0,3.959-1.967A4.915,4.915,0,0,0,10.682,8.473Z",
    transform: "translate(16.306 1.509)",
    fill: "#1899d7",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M6.058,0C2.51,0,.868,1.485.349,5.166L.023,8.485a4.961,4.961,0,0,0,.99,3.524,4.84,4.84,0,0,0,3.9,1.871A5,5,0,0,0,9.22,11.285,4.493,4.493,0,0,0,9.8,9.462l.941-9.45H6.058Z",
    transform: "translate(1.896 1.509)",
    fill: "#1899d7",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.691.043A3.011,3.011,0,0,0,0,3.048v3.9H6.94V3.47C6.952.948,5.467-.247,2.691.043Z",
    transform: "translate(11.007 20.065)",
    fill: "#1899d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H28.967V28.967H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBlue);
export default __webpack_public_path__ + "static/media/house-blue.e4e764e203348865e5300b7a15607ea7.svg";
export { ForwardRef as ReactComponent };